import { LEGACY_AUTH_REDIRECTS } from "app/auth/legacy-auth-redirects";
import { matchPath } from "react-router-dom";
import { allRouteNodes } from "routing/nodes";
import type { RouteNode } from "routing/route";

/** Splits a path into its pathname and its query string plus hash, in whatever order they came in. */
function splitPath(target: string): { pathname: string; rest: string } {
  const url = new URL(target, "http://eventr.invalid");
  return { pathname: url.pathname, rest: `${url.search}${url.hash}` };
}

/**
 * Rewrites a legacy `/authentication/*` path to its canonical registry path, keeping the query
 * string and hash. Matches case-insensitively. An unrecognised path is returned unchanged.
 */
export function canonicaliseAuthPath(target: string): string {
  const { pathname, rest } = splitPath(target);
  const targetPath = pathname.toLowerCase();
  const match = LEGACY_AUTH_REDIRECTS.find(([from]) => {
    const fromLower = from.toLowerCase();
    return targetPath === fromLower || targetPath === fromLower + "/";
  });
  return match ? `${match[1]}${rest}` : target;
}

/** The auth-flow route a path resolves to, canonicalising a legacy path first. */
export function lookupAuthRoute(target: string): RouteNode | undefined {
  const { pathname } = splitPath(canonicaliseAuthPath(target));
  return allRouteNodes.find((node) => node.meta.authFlow && matchPath(node.path, pathname));
}
